import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chat-bubble-ai',
  templateUrl: 'chat-bubble-ai.component.html',
  styleUrls: ['./chat-bubble-ai.component.scss'],
})
export class ChatBubbleAiComponent {
  downloadCertificate(url: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', '');
    anchor.click();
    anchor.remove(); // Clean up the anchor element after clicking
  }
  @Input() message!: string;
  @Input() files: any | null = null; // Accepts files as input, can be null if no files are present
}
